import { useState, useEffect } from "react"
import { authFetch } from "../../utils/api"

const API = process.env.REACT_APP_API_URL

function GestionObrasSociales({ onCambio }) {
  const [obras, setObras]         = useState([])
  const [nombre, setNombre]       = useState("")
  const [mensaje, setMensaje]     = useState(null)
  const [editandoId, setEditandoId] = useState(null)
  const [editNombre, setEditNombre] = useState("")

  const cargar = async () => {
    const res = await authFetch(`${API}/obras-sociales`)
    setObras(await res.json())
  }

  useEffect(() => { cargar() }, [])

  const handleCrear = async () => {
    setMensaje(null)
    if (!nombre.trim()) return
    const res = await authFetch(`${API}/obras-sociales`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre: nombre.trim() }),
    })
    if (res.ok) {
      setNombre("")
      await cargar()
      onCambio?.()
      setMensaje({ tipo: "ok", texto: "Obra social registrada" })
    } else {
      const err = await res.json()
      setMensaje({ tipo: "error", texto: err.error || "Error al registrar" })
    }
  }

  const handleEditar = (os) => {
    if (editandoId === os.id) { setEditandoId(null); return }
    setEditandoId(os.id)
    setEditNombre(os.nombre)
  }

  const handleGuardar = async (id) => {
    if (!editNombre.trim()) return
    const res = await authFetch(`${API}/obras-sociales/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre: editNombre.trim() }),
    })
    if (res.ok) {
      setEditandoId(null)
      await cargar()
      onCambio?.()
    } else {
      const err = await res.json()
      alert(err.error)
    }
  }

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Eliminar "${nombre}"?`)) return
    const res = await authFetch(`${API}/obras-sociales/${id}`, { method: "DELETE" })
    if (res.ok) {
      await cargar()
      onCambio?.()
    } else {
      const err = await res.json()
      alert(err.error)
    }
  }

  return (
    <div className="adminPanel column">
      <div className="adminPanelTitle row">
        <i className="fa-solid fa-building-columns"></i>
        OBRAS SOCIALES
      </div>

      <div className="adminSection">
        <div className="adminSectionLabel">registrar nueva obra social</div>
        <div className="adminRow" style={{ alignItems: "flex-end" }}>
          <div className="adminField">
            <label>nombre</label>
            <input
              type="text"
              placeholder="Nombre de la obra social"
              value={nombre}
              onChange={e => { setNombre(e.target.value); setMensaje(null) }}
              onKeyDown={e => e.key === "Enter" && handleCrear()}
              style={{ width: 220 }}
            />
          </div>
          <button className="adminBtn adminBtn--primary" onClick={handleCrear}>
            registrar
          </button>
        </div>
        {mensaje && (
          <div className={`adminMensaje adminMensaje--${mensaje.tipo}`}>
            {mensaje.texto}
          </div>
        )}
      </div>

      <div className="adminSection">
        <div className="adminSectionLabel">obras sociales registradas</div>
        {obras.length === 0 ? (
          <div className="adminEmptyState">No hay obras sociales registradas.</div>
        ) : (
          <div className="adminPreviewBox">
            <table className="adminPreviewTable">
              <thead>
                <tr>
                  <th style={{ width: 32 }}></th>
                  <th>nombre</th>
                  <th>usuarios</th>
                  <th style={{ width: 32 }}></th>
                </tr>
              </thead>
              <tbody>
                {obras.map(os => {
                  const nUsuarios = os._count?.usuarios ?? 0
                  return (
                    <>
                      <tr key={os.id} className={editandoId === os.id ? "usuarioRowActiva" : ""}>
                        <td>
                          <button
                            className={`usuarioEditBtn${editandoId === os.id ? " usuarioEditBtn--active" : ""}`}
                            onClick={() => handleEditar(os)}
                            title="editar"
                          >
                            <i className={`fa-solid fa-${editandoId === os.id ? "xmark" : "pen"}`}></i>
                          </button>
                        </td>
                        <td>{os.nombre}</td>
                        <td style={{ textAlign: "center" }}>{nUsuarios}</td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            className="usuarioEditBtn adminDanger"
                            title={nUsuarios > 0 ? "Tiene usuarios asignados" : "Eliminar"}
                            onClick={() => handleEliminar(os.id, os.nombre)}
                            disabled={nUsuarios > 0}
                            style={{ opacity: nUsuarios > 0 ? 0.3 : 1 }}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </td>
                      </tr>

                      {editandoId === os.id && (
                        <tr key={`${os.id}-edit`} className="usuarioFormRow">
                          <td colSpan={4}>
                            <div className="usuarioFormInline">
                              <div className="adminSection">
                                <div className="adminSectionLabel">editar nombre</div>
                                <div className="adminRow" style={{ alignItems: "flex-end" }}>
                                  <div className="adminField">
                                    <label>nombre</label>
                                    <input
                                      type="text"
                                      value={editNombre}
                                      onChange={e => setEditNombre(e.target.value)}
                                      onKeyDown={e => e.key === "Enter" && handleGuardar(os.id)}
                                      style={{ width: 220 }}
                                      autoFocus
                                    />
                                  </div>
                                  <button className="adminBtn adminBtn--primary" onClick={() => handleGuardar(os.id)}>
                                    guardar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default GestionObrasSociales
